import script from "./MantenimientoOperativoView.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenimientoOperativoView.vue?vue&type=script&setup=true&lang=js"

import "./MantenimientoOperativoView.vue?vue&type=style&index=0&id=11c633d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c633d4"]])

export default __exports__